export default __webpack_public_path__ + "static/media/touchZero.ed3591d4.svg";